import { Divider, Flex, Input, Select, Tooltip, Typography } from 'antd'
import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { TickIcon } from 'src/assets/icons'
import SearchInputIcon from 'src/assets/images/search-input-icon.png'
import './index.scss'
import { clear } from 'console'

interface IProps {
  name: string
  placeholder: string
  options: any[]
  control: any
  errors: any
  clearErrors: any
  disabled: boolean
  defaultValue: any
}

const SelectWithSearch = (props: IProps) => {
  const { name, control, disabled, options, placeholder, defaultValue, clearErrors } = props
  const [search, setSearch] = useState('')
  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }
  const filterOption = (input: string, option?: any) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  return (
    <Flex>
      <Controller
        name={name}
        control={control}
        disabled={disabled}
        render={({ field, fieldState }) => (
          <Select
            {...field}
            style={{ width: '100%' }}
            maxTagCount='responsive'
            options={options}
            status={fieldState.error ? 'error' : ''}
            placeholder={placeholder}
            mode='multiple'
            maxLength={255}
            // searchValue={search}
            defaultValue={defaultValue}
            filterOption={filterOption}
            showSearch={true}
            autoClearSearchValue={true}
            onSelect={(value) => {
              setSearch('')
            }}
            maxTagPlaceholder={(omittedValues) => (
              <Tooltip title={omittedValues.map(({ label }) => label).join(', ')}>
                <span>+{omittedValues?.length}</span>
              </Tooltip>
            )}
            dropdownRender={(menu) => (
              <Flex vertical style={{ width: '100%' }}>
                <Flex style={{ padding: '8px 12px', width: '100%' }}>
                  <Input
                    onFocus={() => clearErrors(name)}
                    onChange={onSearchChange}
                    placeholder={'Search here'}
                    prefix={<img src={SearchInputIcon} />}
                    style={{ width: '100%', height: 32 }}
                    value={search}
                  />
                </Flex>
                <Divider style={{ margin: 0 }} />
                {menu}
              </Flex>
            )}
            optionRender={(option) => (
              <Flex align='center' justify='space-between'>
                <Typography>{option.label}</Typography>
                {!field?.value.includes(option.value) && <TickIcon />}
              </Flex>
            )}
          ></Select>
        )}
      />
    </Flex>
  )
}

export default SelectWithSearch
